import { logCustomException } from "@sazka/utils/logger/use-app-logger";
import {
    getBankList as httpClientGetBankList,
    Bank,
    getBusinessCardData as httpClientGetBusinessCardData,
    checkBusinessCardData as httpClientCheckBusinessCardData,
} from "../api/business-card-http-client";
import { RegistrationEcode } from "../utils/errors";
import { UrlUtils } from "@sazka/utils/url";
import { useCookieStorage } from "@sazka/utils/use-storage";

let bankList: Bank[] = null;

export const getBankList = async () => {
    if (bankList) {
        return bankList;
    }

    bankList = await httpClientGetBankList();
    return bankList;
};

export const getBusinessCardData = async (code: string) => {
    const data = await httpClientGetBusinessCardData(code);
    if (data.areDataComplete) {
        return data.data;
    }
    return null;
};

export const checkBusinessCardData = async (code: string, fromPopup = false) => {
    const data = await httpClientCheckBusinessCardData(code, fromPopup);
    return data.areDataComplete;
};

export const clearBankIdUrlParams = () => {
    UrlUtils.clearUrlParams(["code", "error", "error_description", "traceId", "state"]);
};

export const handleBankAuthError = (error: string) => {
    if (error == "access_denied") {
        clearBankIdUrlParams();
        return RegistrationEcode.BankIdDeniedByUser;
    } else {
        logCustomException("BankId", "authorization failed", {
            error: error,
            errorDescription: UrlUtils.getQueryString("error_descriptions"),
        });

        clearBankIdUrlParams();
        return RegistrationEcode.InvokeBankIdFailed;
    }
};

export const checkBankIdState = () => {
    const stateFromRedirect = UrlUtils.getQueryString("state");

    const storage = useCookieStorage();
    const cookieName = "bank-id-state";
    const stateFromCookie = storage.getItem(cookieName);
    storage.removeItem(cookieName);

    if (stateFromCookie !== stateFromRedirect) {
        clearBankIdUrlParams();
        return false;
    }

    return true;
};
